import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Channels from "./components/Channels";
import Process from "./components/Process";
import SubmissionForm from "./components/SubmissionForm";
import Categories from "./components/Categories";
import HotTips from "./components/HotTips";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <Navbar />
      <main>
        <Hero />
        <Channels />
        <Process />
        <SubmissionForm />
        <Categories />
        <HotTips />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}